<!-- [PianoPlay](https://michaelecke.com/pianoplay) - Copyright (c) 2021 Rodrigo Jorge Vilar de Linares. -->

<ion-app>
  <ion-router-outlet></ion-router-outlet>
</ion-app>
